// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RGLS","footer":"styles_footer__34ZY_"};